import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/uploads");

export const Route = createFileRoute("/uploads/")({
  head: () => ({
    meta: [
      { title: "Uploads — LevelLoad" },
      { name: "description", content: "Uploads — LevelLoad transport planning." },
      { property: "og:title", content: "Uploads — LevelLoad" },
      { property: "og:description", content: "Uploads — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
